import { render, staticRenderFns } from "./course-list-item.vue?vue&type=template&id=bb23b8de&"
import script from "./course-list-item.vue?vue&type=script&lang=js&"
export * from "./course-list-item.vue?vue&type=script&lang=js&"
import style0 from "./course-list-item.vue?vue&type=style&index=0&id=bb23b8de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports